'use client';

import { captureAttribution } from '@/lib/attribution';
import { useEffect } from 'react';

/**
 * 상담 신청 유입 정보 수집(lib/attribution). 루트 layout 에 한 번 두어 문서를 새로 불러올 때만
 * 기록한다 — layout 은 사이트 안 이동에서 다시 마운트되지 않는다.
 */
export default function AttributionTracker() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return null;
}
